import { CollectionMenuViewStyle, } from './types.js';
export const getItemsByIds = (items) => {
    const itemsById = {};
    items.forEach((item, index) => {
        itemsById[item.id] = Object.assign(Object.assign({}, item), { index });
    });
    return itemsById;
};
export const getOrderedCollections = (items, collections, filterEnabled = true) => {
    const itemsById = getItemsByIds(items);
    const orderedCollections = collections
        .filter(c => { var _a; return itemsById[c.id] && (!filterEnabled || ((_a = itemsById[c.id]) === null || _a === void 0 ? void 0 : _a.enabled)); })
        .sort((c1, c2) => itemsById[c1.id].index - itemsById[c2.id].index);
    const newCollections = collections
        .filter(c => !itemsById[c.id])
        .sort((c1, c2) => c1.customOrderingIndex - c2.customOrderingIndex);
    return [...orderedCollections, ...newCollections];
};
export const getDetailedCollectionItems = (items, collections) => {
    const itemsById = getItemsByIds(items);
    const orderedCollections = getOrderedCollections(items, collections, false);
    return orderedCollections.map(c => {
        var _a, _b;
        return ({
            id: c.id,
            name: c.name,
            enabled: typeof ((_a = itemsById[c.id]) === null || _a === void 0 ? void 0 : _a.enabled) === 'undefined'
                ? true
                : (_b = itemsById[c.id]) === null || _b === void 0 ? void 0 : _b.enabled,
        });
    });
};
export const viewStylesFactory = (intl) => [
    {
        value: CollectionMenuViewStyle.Simple,
        text: intl.$t({ id: 'Generics.Simple', defaultMessage: 'Simple' }),
    },
    {
        value: CollectionMenuViewStyle.Collapsible,
        text: intl.$t({
            id: 'Generics.Collapsible',
            defaultMessage: 'Collapsible',
        }),
    },
    {
        value: CollectionMenuViewStyle.Heading,
        text: intl.$t({ id: 'Generics.Heading', defaultMessage: 'Heading' }),
    },
];
//# sourceMappingURL=utils.js.map